<script>
import PopUp from '@/components/PopUp.vue'
import message from '@/helpers/message'
import CalendarDays from '@/components/Calendar/CalendarDays.vue'

export default {
    components: { PopUp, CalendarDays },
    data() {
        return {
            bookings: null,
            bookingItem: null,
            blockings: [],
            newBooking: { day: null, selected_date: null, isBlocked: false, start_time: null, end_time: null, startMinutes: null, endMinutes: null, id: 0 },
            showSummary: false
        }
    },
    created() {
        this.$communicatorAx.get('add-booking/' + this.$route.params.id)
            .then((data) => {
                this.bookingItem = data.booking;
                this.bookings = data.allBookings;
                this.blockings = data.blockings;
            })
            .catch(function(error) {
                this.$apiErrorhandler.handleErrors(error, this.$route.fullPath)
            });
    },
    methods: {
        getTimeInMinutes(timeString) {
            if (timeString == null) {
                return null;
            }

            const [hours, minutes] = timeString.split(':').map(Number);
            return hours * 60 + minutes;
        },
        formatMinutes(minutes) {
            const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
            const mins = String(minutes % 60).padStart(2, '0');
            return `${hours}:${mins}`;
        },
        getSlotEndMinutes(time) {
            return this.bookingItem.hour_calender_layout == 'Timmar' ? time.minutes + 60 : time.minutes + 30;
        },
        selectTime(time) {
            if (this.checkIfOccupied(time)) {
                return;
            }

            message.removeMessage();

            if (this.newBooking.start_time == null) {
                this.newBooking.start_time = time.timeLabel;
                this.newBooking.startMinutes = time.minutes;
                return;
            }

            if (time.minutes < this.newBooking.startMinutes) {
                return;
            }

            const endMinutes = this.getSlotEndMinutes(time);
            if (endMinutes - this.newBooking.startMinutes > this.bookingItem.duration_time * 60) {
                message.setInfoMessage('Du har valt en längre bokningstid än vad som är möjligt. Maximal bokningstid är ' + this.bookingItem.duration_time + ' ' + this.bookingItem.duration_unit);
                return;
            }

            if (this.occupiedTimesSelectedDay.some(x => this.newBooking.startMinutes < x.end_time_in_minutes && endMinutes > x.start_time_in_minutes)) {
                message.setInfoMessage('Du har valt en tid som ligger över en annan bokning eller blockering. Vänligen ändra tid.');
                return;
            }

            this.newBooking.end_time = time.timeLabelEndTime;
            this.newBooking.endMinutes = endMinutes;
        },
        checkIfOccupied(time) {
            return this.getOverlappingOccupiedItem(time) != null;
        },
        getOverlappingOccupiedItem(time) {
            const slotEndMinutes = this.getSlotEndMinutes(time);
            return this.occupiedTimesSelectedDay.find(x => time.minutes < x.end_time_in_minutes && slotEndMinutes > x.start_time_in_minutes);
        },
        getOccupiedEntry(time) {
            const slotEndMinutes = this.getSlotEndMinutes(time);
            const firstSlotMinutes = this.timeSlots[0]?.minutes;
            return this.occupiedTimesSelectedDay.find(x => {
                const startsInSlot = x.start_time_in_minutes >= time.minutes && x.start_time_in_minutes < slotEndMinutes;
                const continuesIntoFirstSlot = firstSlotMinutes === time.minutes && x.start_time_in_minutes < time.minutes && x.end_time_in_minutes > time.minutes;
                return startsInSlot || continuesIntoFirstSlot;
            });
        },
        isBlockingEntry(time) {
            return this.getOverlappingOccupiedItem(time)?.isBlocking === true;
        },
        getOccupiedTime(time) {
            const occupiedTime = this.getOccupiedEntry(time);

            if (occupiedTime) {
                if (occupiedTime.isBlocking) {
                    const description = occupiedTime.description ? ' - ' + occupiedTime.description : '';
                    return '<b>' + occupiedTime.formatted_start_time + ' - ' + occupiedTime.formatted_end_time + '</b> Blockering' + description;
                }

                const name = occupiedTime.created_by_full_name != null
                    ? occupiedTime.created_by_full_name
                    : (occupiedTime.comments != null && occupiedTime.comments.includes('Återkommande bokning')
                        ? occupiedTime.comments
                        : 'Publik bokning');
                return '<b>' + occupiedTime.formatted_start_time + ' - ' + occupiedTime.formatted_end_time + '</b> ' + name;
            }

            return '';
        },
        getNewBookingStartTime(time) {
            if (time.minutes == this.newBooking.startMinutes) {
                return this.newBooking.start_time + ' - ' + (this.newBooking.end_time ?? '');
            }
        },
        isSelectedTime(time) {
            if (time.minutes == this.newBooking.startMinutes) {
                return true;
            }

            if (this.newBooking.endMinutes) {
                return time.minutes > this.newBooking.startMinutes && time.minutes < this.newBooking.endMinutes;
            }

            return false;
        },
        setNewStartTime() {
            this.newBooking.start_time = null;
            this.newBooking.end_time = null;
            this.newBooking.endMinutes = null;
            this.newBooking.startMinutes = null;
        },
        save() {
            this.newBooking.booking_item_id = this.bookingItem.id;
            this.newBooking.start_date = this.newBooking.selected_date + ' ' + this.newBooking.start_time;
            this.newBooking.end_date = this.newBooking.selected_date + ' ' + this.newBooking.end_time;

            this.$communicatorAx.post('add-booking/', this.newBooking)
                .then((data) => {
                    message.setSuccessMessage();
                    this.$cache.updateCache('bookings', 'bookings/');
                    this.$cache.updateCache('incomingEvents', 'incoming-events/');
                    this.$router.push('/booking')
                })
                .catch(function(error) {
                    if (error.responseJSON.detail == 'already booked') {
                        message.setValidationErrorMessage(['Du har redan en aktiv bokning registerad. Du kan endast ha en bokning registrerad i taget.']);
                    }
                    else if (error.responseJSON.detail == 'max duration exceeded') {
                        message.setValidationErrorMessage(['Du har valt en längre bokningstid än vad som är möjligt. Vänligen välj en kortare bokningstid.']);
                    }
                })
        }
    },
    watch: {
        windowScroll(newvalue) {
            if (newvalue > 150) {
                this.showBookingBar = true;
            }
        },
        'newBooking.day'(day) {
            if (this.$isMobile) {
                if (day != null) {
                    this.$nextTick(() => {
                        $('html, body').animate({
                            scrollTop: $('#BookingHours-times').offset().top
                        })
                    })
                }
            }
        }
    },
    computed: {
        timeSlots() {
            const slots = [];
            for (let hours = this.bookingItem.day_available_start_hour; hours < this.bookingItem.day_available_end_hour; hours++) {
                if (this.bookingItem.hour_calender_layout == 'Timmar') {
                    slots.push({ timeLabel: `${String(hours).padStart(2, '0')}:00`, timeLabelEndTime: `${String(hours + 1).padStart(2, '0')}:00`, minutes: hours * 60 });
                } else {
                    slots.push({ timeLabel: `${String(hours).padStart(2, '0')}:00`, timeLabelEndTime: `${String(hours).padStart(2, '0')}:30`, minutes: hours * 60 });
                    slots.push({ timeLabel: `${String(hours).padStart(2, '0')}:30`, timeLabelEndTime: `${String(hours + 1).padStart(2, '0')}:00`, minutes: hours * 60 + 30 });
                }
            }
            return slots;
        },
        bookingsSelectedDay() {
            if (this.newBooking.date == null) {
                return [];
            }

            return (this.bookings ?? []).filter(x => x.formatted_start_date == this.newBooking.date.toLocaleDateString('sv-SE'));
        },
        blockingsSelectedDay() {
            if (this.newBooking.date == null || this.bookingItem == null) {
                return [];
            }

            const dayStart = new Date(this.newBooking.date.getFullYear(), this.newBooking.date.getMonth(), this.newBooking.date.getDate(), 0, 0, 0, 0);
            const dayEnd = new Date(this.newBooking.date.getFullYear(), this.newBooking.date.getMonth(), this.newBooking.date.getDate() + 1, 0, 0, 0, 0);
            const availabilityStart = this.getTimeInMinutes(this.bookingItem.day_available_start_time);
            const availabilityEnd = this.getTimeInMinutes(this.bookingItem.day_available_end_time);

            return (this.blockings ?? [])
                .map(blocking => {
                    const blockingStart = new Date(blocking.start_date);
                    const blockingEnd = new Date(blocking.end_date);

                    if (blockingEnd <= dayStart || blockingStart >= dayEnd) {
                        return null;
                    }

                    const rangeStart = blockingStart > dayStart ? blockingStart : dayStart;
                    const rangeEnd = blockingEnd < dayEnd ? blockingEnd : dayEnd;
                    const rangeStartMinutes = rangeStart.getTime() <= dayStart.getTime() ? 0 : rangeStart.getHours() * 60 + rangeStart.getMinutes();
                    const rangeEndMinutes = rangeEnd.getTime() >= dayEnd.getTime() ? 24 * 60 : rangeEnd.getHours() * 60 + rangeEnd.getMinutes();
                    const clampedStartMinutes = Math.max(rangeStartMinutes, availabilityStart ?? 0);
                    const clampedEndMinutes = Math.min(rangeEndMinutes, availabilityEnd ?? 24 * 60);

                    if (clampedEndMinutes <= clampedStartMinutes) {
                        return null;
                    }

                    return {
                        start_time_in_minutes: clampedStartMinutes,
                        end_time_in_minutes: clampedEndMinutes,
                        formatted_start_time: this.formatMinutes(clampedStartMinutes),
                        formatted_end_time: this.formatMinutes(clampedEndMinutes),
                        description: blocking.description,
                        isBlocking: true
                    };
                })
                .filter(blocking => blocking != null);
        },
        occupiedTimesSelectedDay() {
            return [...this.bookingsSelectedDay, ...this.blockingsSelectedDay]
                .sort((a, b) => a.start_time_in_minutes - b.start_time_in_minutes);
        }
    }
}
</script>
<template>
    <main class="opacity-white-bg" v-fade-in v-if="bookingItem != null" style="margin-bottom: 174px;">
        <div class="float-right">
            <i class="fa-solid fa-circle" style="color: rgb(189 162 162)"></i> = blockering
        </div>
        <h2>Skapa bokning av {{ bookingItem.name }}</h2>
        <p>Max bokningtid: {{ bookingItem.duration_time }} timmar</p>
        <div class="g-70">
            <CalendarDays :bookings="bookings" :blockings="blockings" :selectedDay="newBooking" :isAdmin="false" :bookingItem="bookingItem"></CalendarDays>
        </div>
        <div class="g-30">
            <div id="BookingHours-times" class="BookingHours-calendar-position" v-if="newBooking.day != null" v-fade-in :class="bookingItem.hour_calender_layout == 'Timmar' ? 'BookingHour-only-hours' : ''">
                <div class="overflow-auto" style="padding-top: 5px;">
                    <div class="g-10">
                        <div v-for="(time, index) in timeSlots" :key="time.minutes" class="time-label" :style="{ 'border-top-style': index % 2 === 1 ? 'dashed' : '' }">
                            <span>{{ index % 2 === 0 || bookingItem.hour_calender_layout == 'Timmar' ? time.timeLabel : '' }}</span>
                        </div>
                    </div>
                    <div class="g-90">
                        <div v-for="(time, index) in timeSlots" :key="time.minutes + '-slot'" class="time-slot" :style="{ 'border-top-style': index % 2 === 1 ? 'dashed' : '' }" :class="[checkIfOccupied(time) ? 'occupied' : '', isBlockingEntry(time) ? 'occupied-blocking' : '', isSelectedTime(time) ? 'selected-time-slot' : '']" @click="selectTime(time)">
                            <span v-if="getOccupiedEntry(time)" v-html="getOccupiedTime(time)" class="occupied occupied-label" :class="{ 'occupied-blocking': isBlockingEntry(time) }"></span>
                            <span v-html="getNewBookingStartTime(time)"></span>
                        </div>
                    </div>
                </div>
                <div class="BookingHours-end-hour"><span>{{ bookingItem.day_available_end_time }}</span></div>
            </div>
        </div>

        <div v-if="showSummary">
            <PopUp>
                <h2>Bokning av {{ bookingItem.name }}</h2>
                <span>
                    Starttid: {{ newBooking.selected_date }} {{ newBooking.start_time }} <br>
                    Sluttid: {{ newBooking.selected_date }} {{ newBooking.end_time }} <br>
                </span>
                <br>
                <label>Lägg till en kommentar (frivillig, kommer bara synas för dig)</label>
                <textarea v-model="newBooking.comments"></textarea>

                <div class="info BookingAdd-info-box">
                    <b style="text-transform: uppercase;">Läs igenom följande information innan du klickar på slutför bokningen:</b>
                    <div class="margin-top-15" v-html="bookingItem.rules"></div>
                </div>
                <div class="margin-top-15 float-right">
                    <button class="btn btn-gray" @click="showSummary = false">Gå tillbaka och ändra</button>
                    <button class="btn" @click="save" style="margin-top: 3px;">Slutför bokningen</button>
                </div>
            </PopUp>
        </div>
    </main>
    <div class="BookingHours-booking-times" v-fade-in>
        <div>
            1. Välj datum
            <h2>{{ newBooking.selected_date }}</h2>
        </div>
        <div>
            <span :style="{ 'opacity': newBooking.selected_date == null ? '0.3' : '1', 'margin': '0px' }">2. Välj Starttid</span>
            <h2>{{ newBooking.start_time }} <button class="btn btn-gray" v-if="newBooking.start_time != null" @click="setNewStartTime">Ändra starttid</button></h2>
        </div>
        <div>
            <p :style="{ 'opacity': newBooking.start_time == null ? '0.3' : '1', 'margin': '0px' }" class="margin-top-15">
                3. Välj Sluttid
            </p>
            <h2>{{ newBooking.end_time }}</h2>
        </div>
        <div class="pc-only">
            <button class="btn margin-top-15 BookingHoursAdd-confirm-btn" v-if="newBooking.end_time != null" @click="showSummary = true">Slutför bokningen</button>
        </div>
        <button class="btn mobile-only margin-top-15 BookingHoursAdd-confirm-btn mobile-100w-btn" v-if="newBooking.end_time != null" @click="showSummary = true">Slutför bokningen</button>
    </div>
</template>
<style scoped>
.time-slot {
    height: 17px;
    border-top: 1px solid #ddd;
    padding: 0px 10px;
    font-size: 12px;
    cursor: pointer;
    position: relative;
}

.time-slot:hover {
    opacity: 0.7;
}

.time-label {
    height: 17px;
    border-top: 1px solid #ddd;
    text-align: center;
    font-size: 12px;
}

.BookingHours-end-hour {
    height: 17px;
    border-top: 1px solid #ddd;
    font-size: 12px;
    margin-left: 4px;
}

.time-label span, .BookingHours-end-hour span {
    margin-top: -10px;
    display: block;
    width: 40px;
    background: white;
}

.BookingHour-only-hours .time-label, .BookingHour-only-hours .time-slot {
    height: 34px;
}

.occupied {
    background: rgb(245, 150, 150);
    border-top: 1px solid rgb(245, 150, 150);
}

.occupied-blocking {
    background: rgb(189 162 162);
    border-top: 1px solid rgb(189 162 162);
}

.occupied-label {
    display: block;
}

.selected-time-slot {
    border-top: 1px solid rgb(154, 217, 154);
    background: rgb(154, 217, 154) !important;
}

.BookingHours-booking-times {
    padding: 14px 10px 0px 10px;
    margin-top: 30px;
    border-radius: 5px;
    text-align: center;
    overflow: auto;
    position: fixed;
    bottom: 0px;
    border-top: 1px solid rgb(133, 133, 133);
    width: calc(100% - 20px);
    left: 0px;
    z-index: 999;
    filter: brightness(1.2);
    background: linear-gradient(180deg, #f9f9f9 0%, #e5e5e5 45%, #fefffe 100%) !important;
}

.BookingHours-booking-times div {
    float: left;
    width: 25%;
    height: 100px;
}

.BookingHours-calendar-position {
    margin: 100px 20px 0px 20px;
    padding: 15px 7px;
    background: white;
    overflow: auto;
}

@media only screen and (max-width: 1000px) {
    .BookingHours-booking-times {
        padding: 14px 10px 0px 10px;
        height: auto;
    }

    .BookingHours-booking-times div {
        float: left;
        width: 33%;
    }

    .g-10 {
        width: 10% !important;
    }

    .g-90 {
        width: 90% !important;
    }

    .BookingHours-calendar-position {
        margin: 40px 20px 0px 20px;
    }
}
</style>
